import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "medical-alert-user-container pl-1 gap" }

import Icon from "@/components/Icons/Icon.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'CreatedBy',
  props: {
  icon: {
    type: String,
    default: 'client-icon'
  },
  color: {
    type: String,
    default: 'primaryColor'
  },
  gap: {
    type: String,
    default: '4px'
  }
},
  setup(__props) {

_useCssVars(_ctx => ({
  "v3b4ab730": (__props.gap)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("span", null, "by", -1)),
    _createVNode(Icon, {
      icon: __props.icon,
      color: __props.color
    }, null, 8, ["icon", "color"])
  ]))
}
}

})